import type { OnboardingState } from '@/redux/slices/onboardingSlice';

export function shouldSkipOnboardingProgressFetch(
  progress: OnboardingState['progress'] | undefined,
): boolean {
  if (!progress) return false;
  return (
    progress.phase1.isCompleted &&
    (progress.phase2.isCompleted || progress.phase2.dismissedAt != null)
  );
}
